import {useEffect, useRef} from "react";
import {Base64} from "js-base64";
import {isEmpty} from "lodash";

export function env(key, defaultValue = null) {
    return process.env[key] ?? (process.env[`REACT_APP_${key}`] ?? defaultValue);
}


export function sleep(seconds) {
    let promise = new Promise(function (resolve) {
        setTimeout(() => {
            return resolve(true);
        }, seconds * 1000);
    });
    return promise;
}

export function useComponentWillReceiveProps(nextProps, callback) {
    const props = useRef(nextProps)
    useEffect(() => {
        callback(nextProps, props.current)
        props.current = nextProps
    });
}

export function searchEncode(search) {
    let queryData = {};
    for (const key in search) {
        let v = search[key];
        let k = v['name'];
        if (v['name'] && v['val'] !== undefined) {
            if (!v.rule) {
                v.rule = '='
            }
            v = [v.rule, v['val']]
            queryData[k] = v;
        }
    }
    return Base64.encode(JSON.stringify(queryData));
}

export function searchDecode(searchQuery) {
    searchQuery = Base64.decode(searchQuery);
    let search = JSON.parse(searchQuery);
    let result = [];
    for (const key in search) {
        result.push({
            name: key,
            rule: search[key][0],
            val: search[key][1]
        });
    }
    return result;
}

export function searchConditionConstructor(condition = {}) {
    let searchCondition = {};
    if (!isEmpty(condition.contractName)) {
        searchCondition['contract_name'] = ['like', condition.contractName];
    }

    if (!isEmpty(condition.mchOrUserName)) {
        searchCondition['name'] = ['like', condition.mchOrUserName];
    }

    if (condition.orderStatus !== undefined) {
        searchCondition['order_batch_status'] = ['=', condition.orderStatus];
    }

    if (condition.orderId !== undefined) {
        searchCondition['order_id'] = ['like', condition.orderId];
    }

    if (condition.remark !== undefined) {
        searchCondition['order_remark'] = ['like', condition.remark];
    }

    if (condition.arrivalDate !== undefined && condition.arrivalDate[0]) {
        searchCondition['contract_batch_arrival_date'] = [
            'between',
            [
                condition.arrivalDate[0].format("YYYY-MM-DD"),
                condition.arrivalDate[1].clone().add(1, 'days').format("YYYY-MM-DD")
            ]
        ];
    }

    if (condition.endTime !== undefined && condition.endTime[0]) {
        searchCondition['contract_batch_end_time'] = [
            'between',
            [
                condition.endTime[0].format("YYYY-MM-DD"),
                condition.endTime[1].clone().add(1, 'days').format("YYYY-MM-DD")
            ]
        ];
    }

    if (condition.orderType !== undefined) {
        searchCondition['order_type'] = ['=', condition.orderType]
    }

    if (condition.deliveryType !== undefined) {
        searchCondition['order_delivery_type'] = ['in', condition.deliveryType];
    }
    return searchCondition;
}

export  function executeConditionConstructor(condition) {
    let executeCondition = {};
    if (condition.summaryType !== undefined) {
        executeCondition['summary_type'] = condition.summaryType;
    }

    if (condition.executeTime !== undefined && condition.executeTime) {
        executeCondition['execute_time'] = condition.executeTime.format('HHmm');
    }

    if (condition.containHours !== undefined && condition.containHours) {
        executeCondition['summary_hours'] = condition.containHours;
    }

    if (condition.beforeDay !== undefined) {
        executeCondition['summary_before_day'] = condition.beforeDay;
    }

    if (condition.rangeTimes !== undefined && condition.rangeTimes[0]) {
        executeCondition['summary_start_time'] = condition.rangeTimes[0].format('HHmm');
        executeCondition['summary_start_time'] = condition.rangeTimes[1].format('HHmm');
    }
    return executeCondition;
}

